import { useSelector, useStore } from 'react-redux'
import { getHitsPerPage } from 'selectors/algolia2/url'
import {
  getHitsTotal,
  getPaginationCurrent,
  getPaginationTotal,
  getUrlStringWithParams,
} from '../helpers/collectionDetailsSelector'

const useCollectionDetailsPagination = () => {
  const store = useStore()

  const hitsPerPage = useSelector(getHitsPerPage)
  const hitsTotal = useSelector(getHitsTotal)
  const currentPage = useSelector(getPaginationCurrent)
  const totalPages = useSelector(getPaginationTotal)

  const urlWithParams = (params: Record<string, any>): string => {
    const selector = getUrlStringWithParams(params)
    return selector(store.getState())
  }

  return {
    hitsPerPage,
    hitsTotal,
    currentPage,
    totalPages,
    urlWithParams,
  }
}

export default useCollectionDetailsPagination
